import React from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { format } from "date-fns";
import User from "../Services/user";

export default function PDFVisualizarProgre() {
  const gerarPDF = async (dados) => {
    if (!dados || dados.length === 0) {
      Alert({
        tipo: "Erro",
        mensagem: "Não há dados para gerar o relatório.",
      });
      return;
    }

    try {
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const pageHeight = 297;
      const imgWidth = 210;
      const dataHoraGeracao = format(new Date(), "dd/MM/yyyy 'às' HH:mm");
      const totalProgressos = `Total de progressões: ${dados.length} `;
      const alturaRodape = 290;

      const chunkSize = 27;

      const criarTabelaHTML = (chunk, indicePagina) => {
        return `
        <div style="width: 800px; font-size: 10px; padding: 10px;">
          <h2 style="text-align: center; margin-bottom: 10px;">Relatório de progressões parciais - ${
            User?.perfil() == "secretaria" ? "Secretaria" : "Coordenação"
          }</h2>
          <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
            <thead>
              <tr style="background-color: #1a2e35; color: white;">
                <th style="border: 1px solid #ddd; padding: 6px;">RM</th>
                <th style="border: 1px solid #ddd; padding: 6px;">Nome</th>
                <th style="border: 1px solid #ddd; padding: 6px;">Turma</th>
                <th style="border: 1px solid #ddd; padding: 6px;">Disciplina</th>
                <th style="border: 1px solid #ddd; padding: 6px;">Cumpriu</th>
                <th style="border: 1px solid #ddd; padding: 6px;">Conceito</th>
                <th style="border: 1px solid #ddd; padding: 6px;">Data Aceitou</th>
                <th style="border: 1px solid #ddd; padding: 6px;">Data Result.</th>
                <th style="border: 1px solid #ddd; padding: 6px;">Enviado Sofia</th>
              </tr>
            </thead>
            <tbody>
              ${chunk
                .map((p, i) => {
                  const status = formatarStatus(p.cumpriu);
                  return `
                    <tr style="background-color: ${i % 2 === 0 ? "#f9f9f9" : "white"};">
                      <td style="border: 1px solid #ddd; padding: 4px;">${p.rm || ""}</td>
                      <td style="border: 1px solid #ddd; padding: 4px;">${p.nome || ""}</td>
                      <td style="border: 1px solid #ddd; padding: 4px;">${
                        somenteCampo(p.turma_rh, false, true) || ""
                      }</td>
                      <td style="border: 1px solid #ddd; padding: 4px;">${
                        somenteCampo(p.disciplina_rh, false, true) || ""
                      }</td>
                      <td style="border: 1px solid #ddd; padding: 4px; color: ${status.color}; font-weight: bold;">${
                    status.texto
                  }</td>
                      <td style="border: 1px solid #ddd; padding: 4px; color: ${
                        p.conceito == "apto" ? "green" : p.conceito == "inapto" ? "red" : "black"
                      }; font-weight: bold;">${p.conceito?.toUpperCase() || "-"}</td>
                      <td style="border: 1px solid #ddd; padding: 4px;">${formatarData(p.aluno_aceitou) || "-"}</td>
                      <td style="border: 1px solid #ddd; padding: 4px;">${formatarData(p.data_resultado) || "-"}</td>
                      <td style="border: 1px solid #ddd; padding: 4px; text-align: center; color: ${
                        p.enviado_ao_sofia ? "green" : "red"
                      }; font-weight: bold;">${p.enviado_ao_sofia ? "SIM" : "NÃO"}</td>
                    </tr>`;
                })
                .join("")}
            </tbody>
          </table>
        </div>
      `;
      };

      for (let i = 0; i < dados.length; i += chunkSize) {
        const chunk = dados.slice(i, i + chunkSize);
        const html = criarTabelaHTML(chunk, i / chunkSize);

        const tempDiv = document.createElement("div");
        tempDiv.style.position = "absolute";
        tempDiv.style.left = "-9999px";
        tempDiv.style.top = "0";
        tempDiv.innerHTML = html;

        document.body.appendChild(tempDiv);

        await new Promise((resolve) => setTimeout(resolve, 300));

        const canvas = await html2canvas(tempDiv, {
          logging: false,
          useCORS: true,
          scale: 2,
        });

        const imgData = canvas.toDataURL("image/png");
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        if (i > 0) pdf.addPage();
        pdf.addImage(imgData, "PNG", 10, 10, imgWidth - 20, imgHeight);

        pdf.setFontSize(10);
        pdf.text(`Gerado em: ${dataHoraGeracao}`, 10, alturaRodape - 5);
        pdf.text(totalProgressos, 10, alturaRodape);

        document.body.removeChild(tempDiv);
      }

      const dataAtual = format(new Date(), "dd-MM-yyyy_HH-mm");
      pdf.save(`relatorio_progressoes_${dataAtual}.pdf`);

      Alert({
        tipo: "Sucesso-popup",
        mensagem: "PDF gerado com sucesso!",
        tempo: 2000,
      });
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      Alert({
        tipo: "Erro",
        mensagem: error.message || "Erro ao gerar o PDF. Tente novamente.",
      });
    }
  };

  function somenteCampo(dado, semMaiusculo = false, tudoMaiusculo = false) {
    if (!dado) return dado;
    let resultado = dado;
    if (resultado?.includes(",")) {
      resultado = resultado.split(",")[1].trim();
    }
    const upper = resultado.toUpperCase();
    if (upper?.includes("TÉCNICO EM") || upper?.includes("TECNICO EM")) {
      resultado = resultado.replace(/TÉCNICO EM|TECNICO EM/gi, "").trim();
    }
    if (upper?.includes("TÉCNOLOGO EM") || upper?.includes("TECNOLOGO EM")) {
      resultado = resultado.replace(/TÉCNOLOGO EM|TECNOLOGO EM/gi, "").trim();
    }
    if (semMaiusculo) return resultado;
    if (tudoMaiusculo) return resultado.toUpperCase();
    return resultado.charAt(0).toUpperCase() + resultado.slice(1).toLowerCase();
  }

  function formatarData(data) {
    try {
      return data ? format(new Date(data), "dd/MM/yyyy") : "-";
    } catch (error) {
      return "Data inválida";
    }
  }

  function formatarStatus(status) {
    return {
      texto: status == 1 ? "ENTREGUE" : status == 0 ? "NÃO ENTREGUE" : "EM ANDAMENTO",
      color: status == 1 ? "green" : status == 0 ? "red" : "gray",
    };
  }

  return { gerarPDF };
}
